export { default as companysService } from './companys-service'
